import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { IdentitySection } from '../components/IdentitySection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-gold/30 selection:text-forest-dark" data-id="element-465">
      <HeroSection data-id="element-466" />
      <StorySection data-id="element-467" />
      <PainSection data-id="element-468" />
      <MechanismSection data-id="element-469" />
      <ProductSection data-id="element-470" />
      <TestimonialsSection data-id="element-471" />
      <OfferSection data-id="element-472" />
      <GuaranteeSection data-id="element-473" />
      <UrgencySection data-id="element-474" />
      <ObjectionsSection data-id="element-475" />
      <IdentitySection data-id="element-476" />
      <FinalCTASection data-id="element-477" />
      <Footer data-id="element-478" />
    </div>;
}